import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPageM from './components/Auth/LoginPage';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { Box, Toolbar, ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';

// Your actual pages/components
import Admindashboard from './components/Admin/admindashboard';
import Items from './components/Auth/Dashboard/pages/Item';
import Prices from './components/Auth/Dashboard/pages/Prices';
import Packages from './components/Auth/Dashboard/pages/Packages';
import Contracts from './components/Auth/Dashboard/pages/Contracts';
import ContractDetails from './components/Auth/Dashboard/pages/ContractDetails';
import Users from './components/Admin/Users';
import Salesmanagerdashboard from './components/Salesmanger/Salesmanagerdashboard';
import Salespersondashboard from './components/Salesperson/Salespersondashboard';
import Invoices from './components/Invoices';
import Team from './components/Salesmanger/Team';
import PaymentHandler from './components/Payment/PaymentHandler';
import PaymentSuccess from './components/Payment/PaymentSuccess';
import PaymentCancel from './components/Payment/PaymentCancel';
import Customers from './components/Admin/Customers';

const drawerWidth = 260;

function App() {
  const [open, setOpen] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('authToken')); // Track token state
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [headerTitle, setHeaderTitle] = useState('JnP Contract Management');

  useEffect(() => {
    // Check if token exists in localStorage and update token state
    const storedToken = localStorage.getItem('authToken');
    const storedUser = localStorage.getItem('user');

    if (storedToken && storedUser) {
      setToken(storedToken);
    } else {
      // Clear partial auth state if either is missing
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      setToken(null);
    }
    setIsAuthChecked(true);
  }, []);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const handleLogout = () => {
    localStorage.removeItem('authToken'); // Remove token
    localStorage.removeItem('user'); // Also remove user data
    setToken(null); // Clear token from state
    window.location.href = '/login'; // Redirect to login page
  };

  // Layout wrapper for authenticated pages
  const ProtectedLayout = ({ children }) => (
    <>
      <Header open={open} handleDrawerOpen={handleDrawerOpen} onLogout={handleLogout} headerTitle={headerTitle} />
      <Sidebar open={open} handleDrawerClose={handleDrawerClose} onMenuSelect={setHeaderTitle} />
      <Box sx={{ display: 'flex' }}>
        <Box component="main" sx={{ flexGrow: 1, p: 0, ml: open ? `${drawerWidth}px` : 0 }}>
          <Toolbar />
          {children}
        </Box>
      </Box>
    </>
  );

  // Get dashboard component based on user type
  const getDashboardComponent = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) return <Navigate to="/login" />;

    switch (user.usertypeid) {
      case 1:
        return <Admindashboard />;
      case 2:
        return <Salesmanagerdashboard />;
      case 3:
        return <Salespersondashboard />; case 4:
        return <Invoices />;
      default:
        return <Admindashboard />;
    }
  };

  // Show nothing until we've checked auth state
  if (!isAuthChecked) {
    return null;
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={!token ? <LoginPageM setToken={setToken} /> : <Navigate to="/" />} />

          {/* Payment Routes */}
          <Route path="/payment/create-session/:contractId" element={<PaymentHandler />} />
          <Route path="/payment/:contractId" element={<PaymentHandler />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />

          {/* Protected Dashboard Route */}
          <Route
            path="/"
            element={
              token ? (
                <ProtectedLayout>
                  {getDashboardComponent()}
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/users"
            element={
              token ? (
                <ProtectedLayout>
                  <Users />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/items"
            element={
              token ? (
                <ProtectedLayout>
                  <Items />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/prices"
            element={
              token ? (
                <ProtectedLayout>
                  <Prices />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/packages"
            element={
              token ? (
                <ProtectedLayout>
                  <Packages />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/contracts"
            element={
              token ? (
                <ProtectedLayout>
                  <Contracts />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/contract-details/:contractId"
            element={
              token ? (
                <ProtectedLayout>
                  <ContractDetails />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/Salesmanagerdashboard"
            element={
              token ? (
                <ProtectedLayout>
                  <Salesmanagerdashboard />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/Team"
            element={
              token ? (
                <ProtectedLayout>
                  <Team />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/Salespersondashboard"
            element={
              token ? (
                <ProtectedLayout>
                  <Salespersondashboard />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />        <Route
          path="/invoices"
          element={
            token ? (
              <ProtectedLayout>
                <Invoices />
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />

          <Route
            path="/customers"
            element={
              token ? (
                <ProtectedLayout>
                  <Customers />
                </ProtectedLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
